import type { ReactNode } from 'react'

export function Card({
  title,
  children,
  footer,
}: {
  title?: string
  children: ReactNode
  footer?: ReactNode
}) {
  return (
    <section className="bg-surface border-line rounded-sm border p-5">
      {title && (
        <h2 className="text-faint border-line mb-4 border-b pb-2 text-[10px] font-medium tracking-[0.14em] uppercase">
          {title}
        </h2>
      )}
      {children}
      {footer && <div className="border-line text-faint mt-4 border-t pt-3 text-xs">{footer}</div>}
    </section>
  )
}

export function DefinitionRow({ label, value }: { label: string; value: ReactNode }) {
  return (
    <div className="border-line flex items-baseline justify-between gap-4 border-b py-2 last:border-0">
      <dt className="text-muted text-sm">{label}</dt>
      <dd className="text-ink tnum font-mono text-sm">{value}</dd>
    </div>
  )
}
